module.exports = __webpack_public_path__ + "img/q7.9ce2bf0c.png";